<section class="section faq-area style-two bg-gray ptb_100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-7">
                <!-- Section Heading -->
                <div class="section-heading text-center">
                    <h2 class="text-capitalize">Frequently asked questions</h2>
                    <p class="d-none d-sm-block mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit.</p>
                    <p class="d-block d-sm-none mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati.</p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-12">
                <!-- FAQ Content -->
                <div class="faq-content">
                    <!-- sApp Accordion -->
                    <div class="accordion" id="sApp-accordion">
                        <div class="row justify-content-center">
                            <div class="col-12 col-md-6">
                                <!-- Single Card -->
                                <div class="card bg-inherit border-0">
                                    <!-- Card Header -->
                                    <div class="card-header bg-inherit border-0 p-0">
                                        <h2 class="mb-0">
                                            <button class="btn px-0 py-3" type="button">
                                                How to install sApp?
                                            </button>
                                        </h2>
                                    </div>
                                    <!-- Card Body -->
                                    <div class="card-body px-0 py-3">
                                        The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text.
                                    </div>
                                </div>
                                <!-- Single Card -->
                                <div class="card bg-inherit border-0">
                                    <!-- Card Header -->
                                    <div class="card-header bg-inherit border-0 p-0">
                                        <h2 class="mb-0">
                                            <button class="btn px-0 py-3" type="button">
                                                Can I get support from the Author?
                                            </button>
                                        </h2>
                                    </div>
                                    <!-- Card Body -->
                                    <div class="card-body px-0 py-3">
                                        Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.
                                    </div>
                                </div>
                                <!-- Single Card -->
                                <div class="card bg-inherit border-0">
                                    <!-- Card Header -->
                                    <div class="card-header bg-inherit border-0 p-0">
                                        <h2 class="mb-0">
                                            <button class="btn px-0 py-3" type="button">
                                                Do you have a free trail?
                                            </button>
                                        </h2>
                                    </div>
                                    <!-- Card Body -->
                                    <div class="card-body px-0 py-3">
                                        It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <!-- Single Card -->
                                <div class="card bg-inherit border-0">
                                    <!-- Card Header -->
                                    <div class="card-header bg-inherit border-0 p-0">
                                        <h2 class="mb-0">
                                            <button class="btn px-0 py-3" type="button">
                                                How can I edit my personal information?
                                            </button>
                                        </h2>
                                    </div>
                                    <!-- Card Body -->
                                    <div class="card-body px-0 py-3">
                                        Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
                                    </div>
                                </div>
                                <!-- Single Card -->
                                <div class="card bg-inherit border-0">
                                    <!-- Card Header -->
                                    <div class="card-header bg-inherit border-0 p-0">
                                        <h2 class="mb-0">
                                            <button class="btn px-0 py-3" type="button">
                                                Contact form isn't working?
                                            </button>
                                        </h2>
                                    </div>
                                    <!-- Card Body -->
                                    <div class="card-body px-0 py-3">
                                        There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
                                    </div>
                                </div>
                                <!-- Single Card -->
                                <div class="card bg-inherit border-0">
                                    <!-- Card Header -->
                                    <div class="card-header bg-inherit border-0 p-0">
                                        <h2 class="mb-0">
                                            <button class="btn px-0 py-3" type="button">
                                                Contact form isn't working?
                                            </button>
                                        </h2>
                                    </div>
                                    <!-- Card Body -->
                                    <div class="card-body px-0 py-3">
                                        There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <p class="text-body text-center pt-4 fw-5">Haven't find suitable answer? <a href="#">Tell us what you need.</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>